import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomUtilityAccountsComponent } from './pages/custom-utility-accounts/custom-utility-accounts.component';
import { CustomConsumptionUploadComponent } from './pages/custom-consumption-upload/custom-consumption-upload.component';
import { CustomFileValidationComponent } from './pages/custom-file-validation/custom-file-validation.component';
import { CustomSupplyDetailsComponent } from './pages/custom-supply-details/custom-supply-details.component';
import { CustomYoureDoneComponent } from './pages/custom-youre-done/custom-youre-done.component';
import { CustomGetQuoteComponent } from './pages/custom-get-quote/custom-get-quote.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { CustomContractDetailsComponent } from './pages/custom-contract-details/custom-contract-details.component';
import { CustomCustomerDetailsComponent } from './pages/custom-customer-details/custom-customer-details.component';

const routes: Routes = [
  { path: ':quoteRequestId/customer-details', component: CustomCustomerDetailsComponent },
  { path: ':quoteRequestId/utility-accounts', component: CustomUtilityAccountsComponent },
  { path: ':quoteRequestId/consumption-data', component: CustomConsumptionUploadComponent },
  { path: ':quoteRequestId/file-validation', component: CustomFileValidationComponent },
  { path: ':quoteRequestId/supply-details', component: CustomSupplyDetailsComponent },
  { path: ':quoteRequestId/get-quote', component: CustomGetQuoteComponent },
  { path: ':quoteRequestId/youre-done', component: CustomYoureDoneComponent },
  { path: ':quoteRequestId/contract-details', component: CustomContractDetailsComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    InlineSVGModule
  ],
  exports: [RouterModule]
})
export class CustomRoutingModule { }
